"use strict";

var _ = require('lodash');
module.exports = /*@ngInject*/function ($scope, $location, $uibModal, ProgramService, RoutingGroupService, ProfileService, ConfigService, $timeout) {
  var ctrl = this;
  ctrl.configurations = [];
  ctrl.selectedRoutingGroup = undefined;
  ctrl.selectedGroup = undefined;
  ctrl.routingGroups = [];
  ctrl.ticketingSystems = [];
  ctrl.groupAction = undefined;
  ctrl.currentUser = ProfileService.getProfile();
  ctrl.isTicketingSystem = false;
  ctrl.helpText = "<ul class='help-steps list-unstyled'><li> Please contact the Service Desk at <a href='mailto:service@RiskandSafetySolutions.com'>service@RiskandSafetySolutions.com</a> to configure new ticketing system.</li></ol>";
  ctrl.setAction = function (action, group) {
    ctrl.reset();
    ctrl.groupAction = action;
    // eslint-disable-next-line no-param-reassign
    group = group || {
      name: undefined,
      members: []
    };
    // eslint-disable-next-line prefer-object-spread
    ctrl.selectedGroup = Object.assign({}, group);
  };
  ctrl.selectProgram = function (program) {
    if (program._id) {
      ProgramService.get({
        id: program._id
      }).$promise.then(function (result) {
        ctrl.selectedProgram = result;
        ctrl.getRoutingGroupsByProgram(ctrl.selectedProgram);
        $location.search('member', null).search('program', result._id).replace();
      });
    }
  };
  ctrl.getRoutingGroupsByProgram = function (program) {
    ctrl.routingGroups = [];
    RoutingGroupService.getRoutingGroupByProgram({
      programId: program._id
    }).$promise.then(function (routingGroups) {
      ctrl.routingGroups = routingGroups || [];
      if (ctrl.routingGroups.length) {
        // eslint-disable-next-line prefer-destructuring
        ctrl.selectedRoutingGroup = ctrl.routingGroups[0];
        ctrl.getRoutingGroup(ctrl.selectedRoutingGroup);
      }
    });
  };
  ctrl.getRoutingGroup = function (routingGroup) {
    RoutingGroupService.get({
      id: routingGroup._id
    }).$promise.then(function (rGroup) {
      ctrl.routingGroup = rGroup;
      ctrl.configurations = ctrl.selectedProgram.configurations.filter(function (configuration) {
        return configuration.routingGroup === rGroup._id;
      }) || [];
      ctrl.isTicketingSystem = ctrl.configurations.some(function (configuration) {
        return !!configuration.ticketingSystem;
      });
    })["catch"](function () {
      ctrl.routingGroup = undefined;
    });
  };
  ctrl.editRoutingGroupDetails = function (routingGroup) {
    $uibModal.open({
      templateUrl: 'management/routing-group/_routing.group.basic-edit-form.html',
      controllerAs: '$ctrl',
      backdrop: 'static',
      // eslint-disable-next-line object-shorthand
      controller: /*@ngInject*/function controller($uibModalInstance) {
        var $ctrl = this;
        $ctrl.routingGroup = {
          _id: routingGroup._id,
          name: routingGroup.name
        };
        $ctrl.validate = function (field) {
          $ctrl['routing-group-form'][field].$error.duplicate = _.some(ctrl.checklists, function (checklist) {
            return checklist.name.toLowerCase() === $ctrl.checklist.name.toLowerCase() && checklist._id !== $ctrl.checklist._id;
          });
          $ctrl['routing-group-form'][field].$setValidity('duplicate', !$ctrl['routing-group-form'][field].$error.duplicate, $ctrl['routing-group-form'][field]);
        };
        $ctrl.submit = function () {
          $ctrl.progress = true;
          RoutingGroupService.updateBasicDetails({
            id: $ctrl.routingGroup._id
          }, $ctrl.routingGroup).$promise.then(function (updatedRoutingGroup) {
            ctrl.routingGroup = updatedRoutingGroup;
            var matchRoutingGroup = ctrl.routingGroups.find(function (rGroup) {
              return rGroup._id === updatedRoutingGroup._id;
            });
            Object.assign(matchRoutingGroup, _.pick(updatedRoutingGroup, ['_id', 'name']));
            $uibModalInstance.dismiss('cancel');
          });
        };
        $ctrl.cancel = function () {
          $uibModalInstance.dismiss('cancel');
          ctrl.setAction(null, null);
        };
      }
    });
  };
  var responseSuccess = function responseSuccess(response) {
    ctrl.hasError = false;
    ctrl.routingGroup = response;
    ctrl.reset();
    ctrl.progress = false;
  };
  var responseError = function responseError(error) {
    ctrl.reset();
    ctrl.progress = false;
    ctrl.hasError = true;
    ctrl.errorMessage = error.message;
  };
  ctrl.selectedPerson = function (person) {
    if (ctrl.selectedGroup) {
      if (!_.some(ctrl.selectedGroup.members, {
        userId: person.userId
      })) {
        var param = {
          id: ctrl.routingGroup._id,
          action: 'CREATE'
        };
        var payload = {
          id: ctrl.selectedGroup.id,
          person: {
            userId: person.userId,
            firstName: person.firstName,
            lastName: person.lastName,
            email: person.email
          }
        };
        RoutingGroupService.upsertPerson(param, payload).$promise.then(function (response) {
          ctrl.routingGroup = response;
          ctrl.person = undefined;
          ctrl.progress = false;
        });
      } else {
        var clonePerson = _.cloneDeep(person);
        ctrl.personExist = true;
        ctrl.personExistMessage = "".concat(clonePerson.lastName, ", ").concat(clonePerson.firstName, " already exists.");
        $timeout(function () {
          ctrl.personExist = false;
          ctrl.personExistMessage = '';
        }, 3000);
      }
    }
    ctrl.person = undefined;
  };
  ctrl.removePerson = function (group, person) {
    var param = {
      id: ctrl.routingGroup._id,
      action: 'DELETE'
    };
    var payload = {
      id: group.id,
      person: {
        userId: person.userId
      }
    };
    RoutingGroupService.upsertPerson(param, payload).$promise.then(responseSuccess);
  };
  ctrl.submitGroup = function (form, group) {
    if (form.$valid) {
      ctrl.progress = true;
      if (ctrl.groupAction === 'EDIT') {
        ctrl.editGroup(form, group);
      } else if (ctrl.groupAction === 'DELETE') {
        ctrl.deleteGroup(group);
      } else {
        ctrl.addGroup(form, group);
      }
    }
  };
  ctrl.validateGroupForm = function (form, data) {
    // eslint-disable-next-line no-param-reassign
    form.name.$error.duplicate = _.some(ctrl.routingGroup.groups, function (group) {
      return group.name.trim().toLowerCase() === data.name.trim().toLowerCase() && group.id !== data.id;
    });
    form.name.$setValidity('duplicate', !form.name.$error.duplicate, form.name);
  };
  ctrl.deleteGroup = function (groupToDelete) {
    var param = {
      id: ctrl.routingGroup._id,
      action: 'DELETE'
    };
    RoutingGroupService.upsertGroupName(param, groupToDelete).$promise.then(responseSuccess)["catch"](responseError);
  };
  ctrl.editGroup = function (form, groupToEdit) {
    if (form.$valid) {
      var param = {
        id: ctrl.routingGroup._id,
        action: 'EDIT'
      };
      RoutingGroupService.upsertGroupName(param, groupToEdit).$promise.then(responseSuccess);
    }
  };
  ctrl.addGroup = function (form, newGroup) {
    if (form.$valid) {
      var param = {
        id: ctrl.routingGroup._id,
        action: 'CREATE'
      };
      RoutingGroupService.upsertGroupName(param, newGroup).$promise.then(responseSuccess);
    }
  };
  ctrl.reset = function () {
    ctrl.progress = false;
    ctrl.groupAction = undefined;
    ctrl.selectedGroup = undefined;
    ctrl.groupName = undefined;
    ctrl.personExist = false;
    ctrl.person = undefined;
    ctrl.personExistMessage = '';
    ctrl.groupExist = false;
  };
  ctrl.initFirst = true;
  $scope.$watch(function () {
    return $location.search();
  }, function (newSearch, oldSearch) {
    if (newSearch.program !== oldSearch.program || ctrl.initFirst) {
      ctrl.reset();
      ctrl.initFirst = false;
      ctrl.selectProgram({
        _id: $location.search().program
      });
    }
  }, true);
};